import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import {IDataRowProps, IUserDataRow} from "../../../../../../core/interfaces/document";
import CustomTextInput from "../../../../../../components/FormComponents/CustomTextInput";
import When from "../../../../../../components/When";
import {useGetCompanyUsers} from "../../../../../../api/DocumentApi";
import {getDataRowHeader} from "../../../../../../core/helpers/dataRowHelper";
import CustomSelect from "../../../../../../components/FormComponents/CustomSelect";
import DataRowActionButtons from "./DataRowActionButtons";

const UserDataRow = (
    {
        dataRow,
        setDataRow,
        isHeaderEnabled,
        isFieldEnabled,
        removeDataRow,
        copyDataRow,
        checklistViewTable,
        isEditMode,
        isActive,
        requiredSubType
    }: IDataRowProps<IUserDataRow>) => {

    const [users] = useGetCompanyUsers();

    const onChangeValue = (e: any) => {
        const value = (e.target.value ?? "");
        setDataRow({
            ...dataRow,
            [e.target.name]: value.length > 0 ? value : undefined
        });
    }
    return <>
        <Row className={checklistViewTable ? "" : "mt-3 mb-3 ms-2 me-2"}>
            <When condition={!checklistViewTable}>
                <Col md={3}>
                    <CustomTextInput
                        isEditMode={isEditMode}
                        disabled={!isHeaderEnabled}
                        name={"header"}
                        placeholder={"t.ex. Medarbetare"}
                        value={getDataRowHeader(dataRow)}
                        onChange={onChangeValue}
                        disableAutocomplete
                    />
                </Col>
            </When>
            <Col md={
                isEditMode && isActive
                    ? checklistViewTable ? 12 : 7
                    : checklistViewTable ? 12 : 9
            }>
                <CustomSelect
                    checklistViewTable={checklistViewTable}
                    required={requiredSubType.includes(dataRow.subType!)}
                    disabled={!isFieldEnabled}
                    isEditMode={true}
                    name={"userId"}
                    value={dataRow.userId ?? undefined}
                    onChange={onChangeValue}
                    options={<>
                        <option value={''}>Välj Medarbetare</option>
                        {users.map(person => <option value={person.userId}>{person.name}</option>)}
                    </>}
                />
            </Col>

            <When condition={isEditMode && isActive}>
                <DataRowActionButtons
                    dataRow={dataRow}
                    removeDataRow={removeDataRow}
                    copyDataRow={copyDataRow}
                />
            </When>
        </Row>

    </>
};



export default UserDataRow;